module.exports = __webpack_public_path__ + "static/media/kitchener.39060a87.jpeg";